import { useEffect } from 'react'
import { prop } from 'ramda'

import { useDataBoxSelector } from 'app/common/data-box-store'
import { sortClasses } from 'app/common/lib/sort'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  classTypeFilterSelection,
  defaultParallelsDataReceiver,
  educationLevelsFilterSelection,
  parallelsFilter,
  parallelsFilterSelection,
  orgsFilterSelection,
  orgTypesFilterSelection,
  schoolYearFilterSelection,
  classesListFilterSelection,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'

import { DetailedSubsidyClassType } from './types'

type Props = { id: string; pending: boolean }

const sortByTitle = sortClasses<{ title: string }>('down', prop('title'))

export const ParallelsFilter = ({ id, pending }: Props) => {
  const orgType = useDataBoxSelector(orgTypesFilterSelection, () => orgTypesFilterSelection.data)
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const years = useDataBoxSelector(schoolYearFilterSelection, () => schoolYearFilterSelection.data)
  const classType = useDataBoxSelector(
    classTypeFilterSelection,
    () => classTypeFilterSelection.data,
  )
  const visible =
    orgType[0] === OrgType.School &&
    orgs.length === 1 &&
    years.length === 1 &&
    classType[0] === DetailedSubsidyClassType.Common

  useEffect(() => {
    parallelsFilterSelection.resetToDefault()
    educationLevelsFilterSelection.resetToDefault()
    classesListFilterSelection.resetToDefault()
    studentListFilterSelection.resetToDefault()
    parallelsFilter.resetToDefault()

    if (visible) {
      parallelsFilter.addDataReceiver(defaultParallelsDataReceiver)
      parallelsFilter.dataReceive()
    }
  }, [orgs, years, classType, visible])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Параллель"
      header="Выбор параллели"
      dataBoxData={parallelsFilter}
      dataBoxSelection={parallelsFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      sortFunc={sortByTitle}
      multiple
      disabled={pending}
    />
  )
}
